import { gql } from '@/shared/types/gql';

/** Per-account AI CIO conversation index (sessionId + title). */
export const AI_CIO_CONVERSATIONS = gql`
  query AiCioConversations {
    aiCioConversations {
      id
      sessionId
      title
      createdAt
      updatedAt
    }
  }
`;
